import { render, staticRenderFns } from "./improt-resources.vue?vue&type=template&id=601e0781&scoped=true"
import script from "./improt-resources.vue?vue&type=script&lang=js"
export * from "./improt-resources.vue?vue&type=script&lang=js"
import style0 from "./improt-resources.vue?vue&type=style&index=0&id=601e0781&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e0781",
  null
  
)

export default component.exports